module.exports = {
    //search ---?referrer=blah@blah.com&q=1
    getQueryStringArgs(search) {
        var qs = (search.length > 0 ? search.substring(1) : "");
        var args = {};
        var items = qs.length ? qs.split("&") : [];
        var item = null;
        var name = null;
        var value = null;
        for (var i = 0; i < items.length; i++) {
            item = items[i].split("=");
            name = decodeURIComponent(item[0]);
            value = decodeURIComponent(item[1]);
            if (name.length) {
                args[name] = value;
            }
        }
        return args;
    }

}


// WEBPACK FOOTER //
// ./src/util/util.js